import dictionary from "./dictionary";
import get from "lodash/get";

/**
 * Runs a function against a notification object to give additional information about it (icon, actions, etc.)
 * Passing in additional arguments can be useful, so it's possible with this parser.
 * */
export default (notification, ...args) =>
    get(dictionary, notification.type, () => null)(notification, ...args);